(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  function arrangeNutvilaRecipe(section) {
    const content = section.querySelector('.nutvila-recipe__legacy');
    if (!content || content.dataset.arranged === 'true') return;
    const ingredientPattern = /^(ingredientai|ingredients|zutaten|ingrédients)\s*:?$/i;
    const methodPattern = /^(gaminimas|method|instructions|zubereitung|préparation)\s*:?$/i;
    const directNodes = [...content.children];
    const ingredientHeading = directNodes.find((node) => /^H[2-4]$/.test(node.tagName) && ingredientPattern.test(node.textContent.trim()));
    const methodHeading = directNodes.find((node) => /^H[2-4]$/.test(node.tagName) && methodPattern.test(node.textContent.trim()));
    let ingredientList;
    let stepList;
    if (ingredientHeading && methodHeading) {
      const start = directNodes.indexOf(ingredientHeading);
      const middle = directNodes.indexOf(methodHeading);
      if (middle <= start) return;
      const nextHeading = directNodes.findIndex((node, index) => index > middle && /^H[1-6]$/.test(node.tagName));
      const end = nextHeading < 0 ? directNodes.length : nextHeading;
      const grid = document.createElement('div');
      grid.className = 'nutvila-recipe__content-grid';
      content.insertBefore(grid, ingredientHeading);
      for (const [from, to] of [[start, middle], [middle, end]]) {
        const panel = document.createElement('div');
        panel.className = 'nutvila-recipe__content-panel';
        for (let index = from; index < to; index++) panel.appendChild(directNodes[index]);
        grid.appendChild(panel);
      }
      ingredientList = grid.querySelector('.nutvila-recipe__content-panel ul');
      stepList = grid.querySelector('.nutvila-recipe__content-panel ol');
      const tip = [...content.children].find((node) => /^H[2-4]$/.test(node.tagName) && /^(patarimas|tip|tipp|astuce)\s*:?$/i.test(node.textContent.trim()));
      if (tip) {
        const tipPanel = document.createElement('aside');
        tipPanel.className = 'nutvila-recipe__tip-panel';
        content.insertBefore(tipPanel, tip);
        let node = tip;
        while (node && (node === tip || node.nodeType !== 1 || !/^H[1-6]$/.test(node.nodeName))) {
          const next = node.nextSibling;
          tipPanel.appendChild(node);
          node = next;
        }
      }
    } else {
      const paragraphs = [...content.querySelectorAll(':scope > p')];
      const boldLabel = (node) => (node.querySelector(':scope > b, :scope > strong')?.textContent || '').trim();
      const ingredientStart = paragraphs.findIndex((node) => ingredientPattern.test(boldLabel(node)));
      const methodStart = paragraphs.findIndex((node) => methodPattern.test(boldLabel(node)));
      if (ingredientStart < 0 || methodStart <= ingredientStart) return;
      const grid = document.createElement('div');
      grid.className = 'nutvila-recipe__content-grid';
      const ingredients = document.createElement('div');
      const method = document.createElement('div');
      ingredients.className = method.className = 'nutvila-recipe__content-panel';
      const heading = (text) => { const h = document.createElement('h2'); h.textContent = text; return h; };
      ingredients.appendChild(heading(section.dataset.ingredientsLabel));
      method.appendChild(heading(section.dataset.stepsLabel));
      ingredientList = document.createElement('ul');
      ingredients.appendChild(ingredientList);
      stepList = document.createElement('ol');
      method.appendChild(stepList);
      const ingredientNodes = paragraphs.slice(ingredientStart, methodStart);
      for (const paragraph of ingredientNodes) {
        const label = boldLabel(paragraph);
        if (label && !ingredientPattern.test(label)) {
          const subheading = document.createElement('h3');
          subheading.textContent = label;
          ingredients.appendChild(subheading);
          ingredientList = document.createElement('ul');
          ingredients.appendChild(ingredientList);
        } else if (!label) {
          const item = document.createElement('li');
          item.textContent = paragraph.textContent.replace(/^\s*[●•]\s*/, '').trim();
          if (item.textContent) ingredientList.appendChild(item);
        }
      }
      const methodNodes = paragraphs.slice(methodStart);
      for (const [index, paragraph] of methodNodes.entries()) {
        const item = document.createElement('li');
        if (index === 0) {
          const copy = paragraph.cloneNode(true);
          copy.querySelector(':scope > b, :scope > strong')?.remove();
          item.textContent = copy.textContent.trim();
        } else {
          item.textContent = paragraph.textContent.trim();
        }
        if (item.textContent) stepList.appendChild(item);
      }
      if (!ingredients.querySelector('li') || !stepList.querySelector('li')) return;
      content.insertBefore(grid, paragraphs[ingredientStart]);
      grid.append(ingredients, method);
      for (const paragraph of [...ingredientNodes, ...methodNodes]) paragraph.remove();
    }
    content.dataset.arranged = 'true';
    const intro = [...content.children].find((node) => node.tagName === 'P');
    if (intro && intro === content.firstElementChild) intro.remove();
    const facts = section.querySelector('[data-recipe-facts]');
    if (facts) {
      const counts = [[content.querySelectorAll('.nutvila-recipe__content-panel ul li').length, section.dataset.ingredientsLabel], [stepList?.querySelectorAll('li').length || 0, section.dataset.stepsLabel]];
      for (const [count, label] of counts) {
        if (!count) continue;
        const fact = document.createElement('span');
        const strong = document.createElement('strong');
        strong.textContent = count.toString();
        fact.append(strong, document.createTextNode(label));
        facts.appendChild(fact);
        facts.hidden = false;
      }
    }
  }
  document.querySelectorAll('.nutvila-recipe').forEach(arrangeNutvilaRecipe);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.nutvila-recipe').forEach(arrangeNutvilaRecipe);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
